/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * Веб баннер
 */
export interface BannerWebListV2 {
  /** Изображение в ленте */
  bannerWebList?: BannerWebV2[];
}

/**
 * Веб баннер
 */
export interface BannerWebV2 {
  /**
   * Первичный ключ
   * @format uuid
   */
  id: string;

  /**
   * Название баннера
   * @example Кредитный баннер
   */
  name: string;

  /**
   * Приоритет стори для кликстрима
   * @format double
   * @example 2
   */
  priority?: number;

  /**
   * ИД оффера из рекомендательной платформы для кликстрима
   * @format int64
   * @example 234
   */
  offerId?: number;

  /**
   * Заголовок в ленте
   * @example Заголовок
   */
  titleListWeb?: string;

  /**
   * Заголовок в оверлее
   * @example Заголовок
   */
  titleViewWeb?: string;

  /**
   * Текст в оверлее
   * @example Текст
   */
  textViewWeb?: string;

  /** Выравнивание текста в оверлее Web */
  textAlignmentViewWeb?: TextAlignmentEnum;

  /**
   * Код цвета фона в ленте
   * @example #CD5C5C
   */
  backgroundColorListWeb?: string;

  /**
   * Код цвета фона в оверлее
   * @example #F08080
   */
  backgroundColorViewWeb?: string;

  /**
   * Показывать кнопку
   * @example true
   */
  showButtonWeb?: boolean;

  /**
   * Текст кнопки
   * @example Нажать
   */
  buttonTextWeb?: string;

  /**
   * Цвет кнопки
   * @example #CD5C5C
   */
  buttonColorWeb?: string;

  /**
   * Цвет текста кнопки
   * @example #F08080
   */
  buttonTextColorWeb?: string;

  /**
   * Ссылка
   * @example https://ru.stackoverflow.com/
   */
  buttonLinkWeb?: string;

  /** Расположение иллюстрации в оверлее Web */
  imagePositionViewWeb?: ImagePositionEnum;

  /**
   * Хэш картинки
   * @format int32
   * @example 234235
   */
  imageListWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 67896789
   */
  imageViewWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 2345243
   */
  backgroundImageListWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 3543534
   */
  backgroundImageViewWebHash?: number;
  viewed?: boolean;
}

/**
 * Расположение иллюстрации в оверлее Web
 */
export enum ImagePositionEnum {
  UP = "UP",
  DOWN = "DOWN",
}

/**
 * Выравнивание текста в оверлее Web
 */
export enum TextAlignmentEnum {
  UP = "UP",
  MIDDLE = "MIDDLE",
  DOWN = "DOWN",
}

/**
 * Список мобильных баннеров
 */
export interface BannerMobileListV2 {
  /** Список мобильных баннеров */
  bannerMobileList?: BannerMobileV2[];
}

/**
 * Мобильный баннер
 */
export interface BannerMobileV2 {
  /**
   * Первичный ключ
   * @format uuid
   */
  id: string;

  /**
   * Название баннера
   * @example Кредитный баннер
   */
  name: string;

  /**
   * Приоритет стори для кликстрима
   * @format double
   * @example 2
   */
  priority?: number;

  /**
   * ИД оффера из рекомендательной платформы для кликстрима
   * @format int64
   * @example 234
   */
  offerId?: number;

  /**
   * Заголовок в ленте
   * @example Заголовок
   */
  titleListMb?: string;

  /**
   * Заголовок в оверлее
   * @example Заголовок
   */
  titleViewMb?: string;

  /**
   * Текст в оверлее
   * @example Текст
   */
  textViewMb?: string;

  /** Выравнивание текста в оверлее */
  textAlignmentViewMb?: TextAlignmentMbEnum;

  /**
   * Код цвета фона в ленте
   * @example #CD5C5C
   */
  backgroundColorListMb?: string;

  /**
   * Код цвета фона в оверлее
   * @example #F08080
   */
  backgroundColorViewMb?: string;

  /**
   * Показывать кнопку
   * @example true
   */
  showButtonMb?: boolean;

  /**
   * Текст кнопки
   * @example Нажать
   */
  buttonTextMb?: string;

  /**
   * Цвет кнопки
   * @example #CD5C5C
   */
  buttonColorMb?: string;

  /**
   * Цвет текста кнопки
   * @example #F08080
   */
  buttonTextColorMb?: string;

  /**
   * Ссылка
   * @example https://ru.stackoverflow.com/
   */
  buttonLinkMb?: string;

  /**
   * Хэш картинки
   * @format int32
   * @example 234235
   */
  backgroundListMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 67896789
   */
  imageListMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 2345243
   */
  backgroundViewMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 3543534
   */
  imageViewMbHash?: number;
  viewed?: boolean;
}

/**
 * Выравнивание текста в оверлее
 */
export enum TextAlignmentMbEnum {
  UP = "UP",
  DOWN = "DOWN",
}

/**
 * Тело ответа на запрос актуальности отображения баннера
 */
export interface BannerShowResp {
  /**
   * Дата обновления признака
   * @format date-time
   */
  localDate?: string;

  /** Признак отображения баннера */
  isShow?: boolean;
}

/**
 * Веб баннер
 */
export interface BannerWeb {
  /**
   * Первичный ключ
   * @format uuid
   */
  id: string;

  /**
   * Название баннера
   * @example Кредитный баннер
   */
  name: string;

  /**
   * Приоритет
   * @format int32
   * @example 1
   */
  priority: number;

  /**
   * Заголовок в ленте
   * @example Заголовок
   */
  titleListWeb?: string;

  /**
   * Заголовок в оверлее
   * @example Заголовок
   */
  titleViewWeb?: string;

  /**
   * Текст в оверлее
   * @example Текст
   */
  textViewWeb?: string;

  /** Выравнивание текста в оверлее Web */
  textAlignmentViewWeb?: TextAlignmentEnum;

  /**
   * Код цвета фона в ленте
   * @example #CD5C5C
   */
  backgroundColorListWeb?: string;

  /**
   * Код цвета фона в оверлее
   * @example #F08080
   */
  backgroundColorViewWeb?: string;

  /**
   * Показывать кнопку
   * @example true
   */
  showButtonWeb?: boolean;

  /**
   * Текст кнопки
   * @example Нажать
   */
  buttonTextWeb?: string;

  /**
   * Цвет кнопки
   * @example #CD5C5C
   */
  buttonColorWeb?: string;

  /**
   * Цвет текста кнопки
   * @example #F08080
   */
  buttonTextColorWeb?: string;

  /**
   * Ссылка
   * @example https://ru.stackoverflow.com/
   */
  buttonLinkWeb?: string;

  /** Расположение иллюстрации в оверлее Web */
  imagePositionViewWeb?: ImagePositionEnum;

  /**
   * Хэш картинки
   * @format int32
   * @example 234235
   */
  imageListWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 67896789
   */
  imageViewWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 2345243
   */
  backgroundImageListWebHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 3543534
   */
  backgroundImageViewWebHash?: number;
  viewed?: boolean;
}

/**
 * Веб баннер
 */
export interface BannerWebList {
  /** Изображение в ленте */
  bannerWebList?: BannerWeb[];
}

/**
 * Мобильный баннер
 */
export interface BannerMobile {
  /**
   * Первичный ключ
   * @format uuid
   */
  id: string;

  /**
   * Название баннера
   * @example Кредитный баннер
   */
  name: string;

  /**
   * Приоритет
   * @format int32
   * @example 1
   */
  priority: number;

  /**
   * Заголовок в ленте
   * @example Заголовок
   */
  titleListMb?: string;

  /**
   * Заголовок в оверлее
   * @example Заголовок
   */
  titleViewMb?: string;

  /**
   * Текст в оверлее
   * @example Текст
   */
  textViewMb?: string;

  /** Выравнивание текста в оверлее */
  textAlignmentViewMb?: TextAlignmentMbEnum;

  /**
   * Код цвета фона в ленте
   * @example #CD5C5C
   */
  backgroundColorListMb?: string;

  /**
   * Код цвета фона в оверлее
   * @example #F08080
   */
  backgroundColorViewMb?: string;

  /**
   * Показывать кнопку
   * @example true
   */
  showButtonMb?: boolean;

  /**
   * Текст кнопки
   * @example Нажать
   */
  buttonTextMb?: string;

  /**
   * Цвет кнопки
   * @example #CD5C5C
   */
  buttonColorMb?: string;

  /**
   * Цвет текста кнопки
   * @example #F08080
   */
  buttonTextColorMb?: string;

  /**
   * Ссылка
   * @example https://ru.stackoverflow.com/
   */
  buttonLinkMb?: string;

  /**
   * Хэш картинки
   * @format int32
   * @example 234235
   */
  backgroundListMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 67896789
   */
  imageListMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 2345243
   */
  backgroundViewMbHash?: number;

  /**
   * Хэш картинки
   * @format int32
   * @example 3543534
   */
  imageViewMbHash?: number;
  viewed?: boolean;
}

/**
 * Список мобильных баннеров
 */
export interface BannerMobileList {
  /** Список мобильных баннеров */
  bannerMobileList?: BannerMobile[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис баннеров
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-banners.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Полномочия представителя ЮЛ <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=74536693)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Баннеры V2
     * @name MarkAsReadV2
     * @summary Признак просмотренности баннеров
     * @request POST:/api/banners/v2/external/banners/mark-as-read
     */
    markAsReadV2: (data: string[], params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/banners/v2/external/banners/mark-as-read`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name MarkAsRead
     * @summary Признак просмотренности баннеров
     * @request POST:/api/banners/v1/external/banners/mark-as-read
     */
    markAsRead: (data: string[], params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/banners/v1/external/banners/mark-as-read`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры V2
     * @name GetWebBannersV2
     * @summary Список веб баннеров
     * @request GET:/api/banners/v2/external/banners/web
     */
    getWebBannersV2: (params: RequestParams = {}) =>
      this.request<BannerWebListV2, GenericError>({
        path: `/api/banners/v2/external/banners/web`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры V2
     * @name GetMbBannersV2
     * @summary Список мобильных баннеров
     * @request GET:/api/banners/v2/external/banners/mb
     */
    getMbBannersV2: (params: RequestParams = {}) =>
      this.request<BannerMobileListV2, GenericError>({
        path: `/api/banners/v2/external/banners/mb`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры V2
     * @name GetWebImageExternalV2
     * @summary Веб картинка
     * @request GET:/api/banners/v2/external/banners/image/web/{bannerId}
     */
    getWebImageExternalV2: (
      bannerId: string,
      query: { background: boolean; bigBanner: boolean },
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/banners/v2/external/banners/image/web/${bannerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры V2
     * @name GetMbImageExternalV2
     * @summary Мобильная картинка
     * @request GET:/api/banners/v2/external/banners/image/mb/{bannerId}
     */
    getMbImageExternalV2: (
      bannerId: string,
      query: { background: boolean; bigBanner: boolean },
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/banners/v2/external/banners/image/mb/${bannerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Актуальность отображения баннера
     * @name GetBannersActualShow
     * @summary Получение актуальности отображения баннера
     * @request GET:/api/banners/v1/external/show
     */
    getBannersActualShow: (params: RequestParams = {}) =>
      this.request<BannerShowResp, GenericError>({
        path: `/api/banners/v1/external/show`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name GetWebBanners
     * @summary Список веб баннеров
     * @request GET:/api/banners/v1/external/banners/web
     */
    getWebBanners: (params: RequestParams = {}) =>
      this.request<BannerWebList, GenericError>({
        path: `/api/banners/v1/external/banners/web`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name GetMbBanners
     * @summary Список мобильных баннеров
     * @request GET:/api/banners/v1/external/banners/mb
     */
    getMbBanners: (params: RequestParams = {}) =>
      this.request<BannerMobileList, GenericError>({
        path: `/api/banners/v1/external/banners/mb`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name GetWebImageExternal
     * @summary Веб картинка
     * @request GET:/api/banners/v1/external/banners/image/web/{bannerId}
     */
    getWebImageExternal: (
      bannerId: string,
      query: { background: boolean; bigBanner: boolean },
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/banners/v1/external/banners/image/web/${bannerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Баннеры
     * @name GetMbImageExternal
     * @summary Мобильная картинка
     * @request GET:/api/banners/v1/external/banners/image/mb/{bannerId}
     */
    getMbImageExternal: (
      bannerId: string,
      query: { background: boolean; bigBanner: boolean },
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/banners/v1/external/banners/image/mb/${bannerId}`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
}

export const api = new Api();
